import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment';
import { faClock } from '@fortawesome/free-solid-svg-icons';


export const AttendanceDetails = ({ attendance, show = "Employee" }) => {
    const getClassNameBasedOnStatus = (status) => {
        if (status === "Present") {
            return "badge bg-success"
        }
        else if (status === "Absent" || status === "LOP" || status === "NA") {
            return "badge bg-danger"
        }
        else if (status === "Leave") {
            return "badge bg-warning"
        }
        else if (status === "WeeklyOff") {
            return "badge bg-primary"
        }
        return "badge bg-secondary";
    }

    const getNameBasedOnStatus = (status, date) => {
        if (status === "NA") {
            let dateToCheck = moment(date);
            let diffInDays = dateToCheck.diff(moment().startOf('day'), 'days');
            if (diffInDays >= 0) {
                return "--"
            }
            return "Absent"
        }
        else if (status === "WeeklyOff") {
            return "Weekly Off"
        }
        return status;
    }

    return (
        <div className="d-flex justify-content-between">
            {attendance &&
                <>
                    <div>
                        {show === "Employee" &&
                            <div style={{ fontWeight: "bold" }}>{attendance.employeeName}</div>
                        }
                        {show === "Date" &&
                            <div style={{ fontWeight: "bold" }}>{moment(attendance.date).format("DD/MM/YYYY, dddd")}</div>
                        }
                        {(attendance.status === "Present" || attendance.status == "HalfDay") &&
                            <>
                                <div>{moment(attendance.inTime).format("hh:mm A")}
                                    {attendance.workingHours > 0 &&
                                        <> - {moment(attendance.outTime).format("hh:mm A")}</>
                                    }
                                </div>
                                {attendance.workingHours > 0 &&
                                    <div className="d-flex">
                                        <div className="alert alert-sm alert-primary p-1">
                                            <FontAwesomeIcon icon={faClock} className="me-1" />{moment.utc(attendance.workingHours * 60 * 60 * 1000).format("HH:mm")}
                                        </div>
                                        {attendance.lateLoginTime > 0 &&
                                            <div className="alert alert-danger p-1 ms-2">
                                                Late by {moment.utc(attendance.lateLoginTime * 60 * 1000).format("HH:mm")}
                                            </div>
                                        }
                                        {attendance.earlyLogoutTime > 0 &&
                                            <div className="alert alert-danger p-1 ms-2">
                                                Left Early by {moment.utc(attendance.earlyLogoutTime * 60 * 1000).format("HH:mm")}
                                            </div>
                                        }
                                        {attendance.isAutoLogout &&
                                            <div className="alert alert-danger p-1 ms-2">
                                                Auto Logout
                                            </div>
                                        }
                                    </div>
                                }
                            </>
                        }
                    </div>
                    <div>
                        <div className={getClassNameBasedOnStatus(attendance.status)}>{getNameBasedOnStatus(attendance.status, attendance.date)}</div>
                    </div>
                </>
            }
        </div>
    )
};
